export default __webpack_public_path__ + "static/media/100008.3247f577.jpg";